import React from 'react';
import Chart from 'react-apexcharts';
import { rowchartOptions } from '../charts';
import './RowBarChartCard.css';

const RowBarChartCard = ({ rowBarChartData, label, rowBarChartTitle }) => {
    const chartOptions = {
        ...rowchartOptions,
        xaxis: {
            ...rowchartOptions.xaxis,  // Preserve the type option
            categories: rowBarChartData.categories,  // Use categories from props
            title: {
                text: label  // Set the label for x-axis here
            },
        }
    };
    return (
        <div className='rowBarChartCard'>
            <Chart
                options={chartOptions} // Area chart options
                series={rowBarChartData.series}   // Values for the area chart
                type="bar"                     // Chart type
                // height={rowBarChartHeight}                    // Adjust the height if needed
            />
            <p>{rowBarChartTitle}</p>
        </div>
    )
}

export default RowBarChartCard